/**
 * The CSRF token for fetch requests that Inertia doesn't handle automatically
 * (e.g. raw `fetch` calls to JSON-only endpoints).
 *
 * Reads the `XSRF-TOKEN` cookie first: inertia_rails rewrites it on every
 * response, so it follows the session even after a sign-in in another tab. The
 * `<meta>` tag is only rendered on a full page load and goes stale in that case.
 */
export function getCsrfToken(): string {
	const cookie = document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]*)/)?.[1];
	if (cookie) {
		try {
			return decodeURIComponent(cookie);
		} catch {
			// Not written by Rails (its tokens never contain %); use the meta tag.
		}
	}

	return (
		document
			.querySelector('meta[name="csrf-token"]')
			?.getAttribute("content") || ""
	);
}
